// Espace membre, Points Club et formulaire « Poster » — référence : les autres langues fournissent les mêmes clés
const community = {
  account: {
    memberSince: 'Inscrit(e) depuis le {{date}}',
    points: '{{count}} points',
    postCta: 'Partager un deal',
    newBadge: 'Nouveau',
    loginPrompt: 'Connectez-vous pour accéder à votre espace membre.',
    loading: 'Chargement…',
    loadError: 'Impossible de charger ces informations.',
    retry: 'Réessayer',
    sections: {
      saved: 'Contenu sauvegardé',
      contributions: 'Contributions',
      club: 'Points Club',
      rewards: 'Boutique cadeaux',
      stats: 'Statistiques',
      badges: 'Badges',
      expertise: 'Expertise',
    },
    saved: {
      empty: 'Aucun deal sauvegardé',
      emptyHint: 'Touchez le marque-page d\'un deal pour le retrouver ici.',
      browse: 'Parcourir les deals',
      expired: 'Expiré le {{date}}',
      free: 'Gratuit',
      at: 'Dispo. chez {{merchant}}',
      sharedBy: 'Partagé par {{pseudo}}',
      remove: 'Retirer des sauvegardes',
      removed: 'Deal retiré de vos sauvegardes',
      seeDeal: 'Voir le deal',
    },
    contributions: {
      tabActivity: 'Activité',
      tabDeals: 'Deals partagés',
      tabComments: 'Commentaires',
      emptyDeals: 'Oooh :( Vous n\'avez encore rien posté…',
      emptyDealsHint: 'Partagez votre premier bon plan : chaque deal publié vous rapporte des points à échanger contre des cadeaux.',
      postDeal: 'Poster un deal',
      commentedOn: 'A commenté le {{date}}',
      sharedDeal: 'A partagé un deal le {{date}}',
      status: {
        pending: 'En attente de validation',
        approved: 'Publié',
        rejected: 'Refusé',
      },
      viewDeal: 'Voir le deal',
      recentOnly: 'Nous ne montrons que l\'activité la plus récente.',
      partner: 'Marchand partenaire',
      reason: 'Motif : {{note}}',
      pointsEarned: '+{{points}} points gagnés',
      pendingHint: 'L\'équipe vérifie votre deal.',
      cancel: 'Retirer',
      cancelConfirm: 'Retirer ce deal de la file de validation ?',
      cancelled: 'Deal retiré',
      emptyComments: 'Vous n\'avez encore rien commenté',
      emptyCommentsHint: 'Donnez votre avis sur les deals pour aider la communauté.',
    },
  },
  club: {
    title: 'Points Club',
    closed: 'Le Points Club est momentanément fermé : vos points restent acquis.',
    available: 'Points disponibles',
    pending: 'En maturation',
    lifetime: 'Total gagné',
    goToShop: 'Boutique cadeaux',
    pendingHint: 'Les points d\'un deal sont débloqués {{days}} jours après sa publication.',
    level: 'Niveau {{level}}',
    nextLevel: 'Encore {{points}} points pour le niveau {{level}}',
    maxLevel: 'Vous avez atteint le niveau maximum !',
    levelBasis: 'Votre niveau dépend des points gagnés sur 12 mois ({{points}}) : échanger des points ne le fait pas baisser.',
    levels: {
      bronze: 'Bronze',
      silver: 'Argent',
      gold: 'Or',
      platinum: 'Platine',
    },
    howToEarn: 'Comment gagner des points',
    last12Months: '(points gagnés sur 12 mois)',
    earn: {
      dealApproved: 'Deal publié',
      dealApprovedHint: '{{points}} points pour chaque deal accepté par l\'équipe',
      partnerBonus: 'Marchand partenaire',
      partnerBonusHint: '+{{points}} points si le marchand est partenaire de PromoDeep',
      firstDeal: 'Premier deal',
      firstDealHint: '+{{points}} points pour votre tout premier deal publié',
      dealHot: 'Deal hot',
      dealHotHint: '+{{points}} points quand votre deal atteint {{threshold}}°',
      weeklyVotes: 'Votes hebdomadaires',
      weeklyVotesHint: '{{points}} point chaque semaine où vous votez au moins {{count}} fois',
      voteStreak: 'Série de votes hebdo.',
    },
    weekProgress: 'Cette semaine ({{start}} – {{end}}) : {{votes}}/{{required}} votes',
    streak: 'Série en cours : {{weeks}} sem.',
    nextStreakBonus: 'prochain bonus : +{{points}} à {{weeks}} sem.',
    weeksShort: '{{weeks}} sem.',
    levelsTitle: 'Niveaux et avantages',
    levelFrom: 'Dès {{points}} points',
    currentLevel: 'Votre niveau',
    multiplier: 'Points des deals ×{{value}}',
    platinumPerk: 'Deals publiés en priorité',
    history: 'Historique des points',
    historyEmpty: 'Aucun mouvement de points pour le moment.',
    reasons: {
      dealApproved: 'Deal publié',
      partnerBonus: 'Bonus marchand partenaire',
      firstDeal: 'Bonus premier deal',
      dealHot: 'Deal hot',
      weeklyVotes: 'Votes de la semaine',
      voteStreak: 'Bonus série de votes',
      adminAdjust: 'Ajustement de l\'équipe',
      redeem: 'Échange contre un cadeau',
      redeemRefund: 'Points rendus',
      revoked: 'Points retirés',
    },
    lockedUntil: 'disponible le {{date}}',
    showMore: 'Tout afficher',
    showLess: 'Afficher moins',
    leaderboard: 'Top contributeurs (12 mois)',
    leaderboardEmpty: 'Le classement est encore vide : soyez le premier !',
    you: 'Vous',
    rules: 'Les points récompensent des deals utiles à la communauté. Un abus (faux deal, doublon, lien personnel) peut entraîner le retrait des points.',
    shop: {
      title: 'Boutique cadeaux',
      intro: 'Échangez vos points contre des cartes cadeaux et des avantages exclusifs.',
      limit: 'Jusqu\'à {{count}} cadeaux par mois. Chaque demande est vérifiée par l\'équipe.',
      empty: 'Aucun cadeau disponible pour le moment.',
      types: {
        giftCard: 'Carte cadeau',
        goodies: 'Goodies',
        perk: 'Avantage',
      },
      stockLeft: '{{count}} restant(s)',
      missing: 'Encore {{points}} points',
      requiresLevel: 'Niveau {{level}} requis',
      outOfStock: 'Rupture de stock',
      redeem: 'Échanger',
      redeeming: 'Envoi…',
      confirm: 'Échanger {{points}} points contre « {{name}} » ?',
      success: 'Demande envoyée ! Votre cadeau apparaîtra ici dès qu\'il sera prêt.',
      copied: 'Code copié',
      myRewards: 'Mes cadeaux',
      myRewardsEmpty: 'Vous n\'avez encore demandé aucun cadeau.',
      cost: '{{points}} points',
      code: 'Votre code :',
      copy: 'Copier',
      status: {
        pending: 'En préparation',
        fulfilled: 'Envoyé',
        rejected: 'Refusé (points rendus)',
      },
    },
    stats: {
      privateHint: 'Ces statistiques ne sont visibles que par vous.',
      deals: 'Vos deals',
      published: 'Deals publiés',
      pending: '{{count}} en attente',
      hotDeals: 'Deals hot (≥ {{threshold}}°)',
      avgScore: 'Température moyenne (12 mois)',
      maxScore: 'Température la plus élevée',
      views: 'Vues de vos deals',
      partnerDeals: 'Deals partenaires',
      commentsReceived: 'Commentaires reçus',
      comments: 'Vos commentaires',
      commentsPosted: 'Commentaires postés',
      discussions: 'Deals commentés',
      community: 'Votre communauté',
      friends: 'Amis',
      followers: 'Abonnés',
      favorites: 'Deals sauvegardés',
      votes: 'Vos votes',
      totalVotes: 'Total des votes',
      votes12m: 'Votes (12 mois)',
      hotVoted: 'Deals votés devenus hot',
      categories: 'Catégories votées',
      seeBadges: 'Voir mes badges',
    },
    badges: {
      intro: 'Débloquez des badges en partageant, commentant et votant.',
      count: '{{unlocked}}/{{total}} badges obtenus',
      filterAll: 'Tous',
      unlocked: 'Obtenu',
      inProgress: 'En cours',
      locked: 'Verrouillé',
      lockedHint: 'Obtenez d\'abord le badge « {{name}} » pour débloquer celui-ci.',
      none: 'Aucun badge dans cette liste.',
      items: {
        firstDeal: { name: 'Premier pas', desc: 'Publiez votre premier deal.' },
        dealHunter: { name: 'Chasseur de deals', desc: 'Publiez {{count}} deals.' },
        dealMaster: { name: 'Maître des bons plans', desc: 'Publiez {{count}} deals.' },
        firstHot: { name: 'Ça chauffe !', desc: 'Un de vos deals devient hot.' },
        hotMaker: { name: 'Faiseur de hot', desc: '{{count}} de vos deals deviennent hot.' },
        partnerScout: { name: 'Éclaireur partenaire', desc: 'Publiez {{count}} deals chez des marchands partenaires.' },
        popular: { name: 'Star des vitrines', desc: 'Vos deals totalisent {{count}} vues.' },
        commentator: { name: 'Bavard', desc: 'Postez {{count}} commentaires.' },
        talker: { name: 'Orateur', desc: 'Postez {{count}} commentaires.' },
        voter: { name: 'Citoyen', desc: 'Votez {{count}} fois.' },
        superVoter: { name: 'Grand électeur', desc: 'Votez {{count}} fois.' },
        explorer: { name: 'Explorateur', desc: 'Votez dans {{count}} catégories différentes en 12 mois.' },
        loyal: { name: 'Fidèle', desc: 'Votez {{count}} semaines d\'affilée.' },
        collector: { name: 'Collectionneur', desc: 'Sauvegardez {{count}} deals.' },
        social: { name: 'Sociable', desc: 'Ayez {{count}} amis sur PromoDeep.' },
        veteran: { name: 'Vétéran', desc: 'Soyez membre depuis {{count}} jours.' },
        silver: { name: 'Contributeur Argent', desc: 'Atteignez le niveau Argent du Points Club.' },
        gold: { name: 'Contributeur Or', desc: 'Atteignez le niveau Or du Points Club.' },
        platinum: { name: 'Contributeur Platine', desc: 'Atteignez le niveau Platine du Points Club.' },
        expert: { name: 'Expert', desc: 'Obtenez un label d\'expertise dans une catégorie.' },
      },
    },
    expertise: {
      beta: 'Bêta',
      yours: 'Votre expertise',
      rule: 'Le label Expert d\'une catégorie est obtenu avec au moins {{deals}} deals publiés, dont {{hot}} deals hot, sur 12 mois.',
      none: 'Pas encore de label d\'expertise',
      noneHint: 'Continuez à publier des deals de qualité et à animer la communauté.',
      postLink: 'Publier un deal',
      expertIn: 'Expert {{category}}',
      period: 'Période analysée : {{start}} – {{end}}',
      progressTitle: 'Votre progression par catégorie',
      expert: 'Expert',
      progress: '{{deals}}/{{minDeals}} deals · {{hot}}/{{minHot}} deals hot',
      whatTitle: 'Qu\'est-ce que c\'est ?',
      intro: 'L\'Expertise est une reconnaissance accordée aux membres dont les deals aident régulièrement la communauté. Pas besoin de postuler : nous regardons ce que vous partagez déjà, et le label est attribué automatiquement.',
      howTitle: 'Comment ça marche',
      how1Title: 'Le titre se mérite, il ne se demande pas',
      how1: 'Nous analysons les deals que vous partagez : les contributeurs les plus utiles d\'une catégorie l\'obtiennent automatiquement.',
      how2Title: 'Calcul en temps réel',
      how2: 'Pas d\'attente de 4 mois : votre progression est recalculée à chaque vote, sur les 12 derniers mois.',
      how3Title: 'Animez la conversation',
      how3: 'Un deal de qualité, c\'est aussi répondre aux questions dans les commentaires en tant qu\'auteur.',
      how4Title: 'Un label contextuel',
      how4: 'Le label apparaît à côté de votre pseudo dans les catégories où vous êtes expert.',
    },
  },
  post: {
    title: 'Partager un deal',
    loginPrompt: 'Connectez-vous pour partager un deal et gagner des points à échanger contre des cadeaux.',
    stepLink: 'Lien',
    stepDetails: 'Détails',
    stepReview: 'Validation',
    subtitle: 'Collez le lien de l\'offre : nous reconnaissons le marchand et pré-remplissons le formulaire pour vous.',
    urlLabel: 'Lien de l\'offre',
    urlPlaceholder: 'https://…',
    paste: 'Coller',
    pasteNoLink: 'Aucun lien trouvé dans le presse-papier. Copiez le lien de l\'offre puis réessayez.',
    shareTip: 'Sur mobile, encore plus simple : sur le site du marchand, touchez « Partager » et choisissez PromoDeep (application installée).',
    analyzing: 'Analyse…',
    analyze: 'Continuer',
    unknownMerchant: 'Marchand : {{host}}',
    partner: 'Marchand partenaire',
    partnerHint: 'jusqu\'à {{points}} points à gagner',
    notPartner: 'Marchand non partenaire',
    notPartnerHint: '{{points}} points à gagner',
    notPartnerInfo: 'Ce marchand n\'est pas partenaire de PromoDeep : votre deal rapportera {{points}} points, contre {{partnerPoints}} chez un marchand partenaire.',
    changeUrl: 'Changer de lien',
    duplicate: 'Ce deal a déjà été partagé récemment.',
    duplicateLink: 'Voir le deal',
    type: 'Type de deal',
    typeGoodPlan: 'Bon plan',
    typePromoCode: 'Code promo',
    titleLabel: 'Titre',
    titlePlaceholder: 'Ex. : Casque Sony WH-1000XM5 à 249 € chez Fnac',
    titleLength: 'Le titre doit contenir entre 5 et 200 caractères.',
    promoCode: 'Code promo',
    price: 'Prix du deal (€)',
    oldPrice: 'Prix habituel (€)',
    discount: '-{{percent}} %',
    delivery: 'Frais de port',
    deliveryPlaceholder: 'Ex. : Gratuit',
    category: 'Catégorie',
    chooseCategory: 'Choisir une catégorie',
    picture: 'Image',
    pictureBroken: 'Cette image ne peut pas être affichée : elle ne sera pas envoyée.',
    pictureNone: 'Aucune image',
    pictureOthers: 'Autres images trouvées sur la page',
    pictureUpload: 'Joindre une image',
    pictureFromLink: 'Coller le lien d\'une image',
    pictureLinkPlaceholder: 'https://…/image.jpg',
    pictureUseLink: 'Utiliser',
    pictureHint: 'JPEG, PNG, WebP, GIF ou AVIF, 5 Mo maximum. Vous pouvez aussi glisser-déposer une image ici.',
    pictureRemove: 'Retirer l\'image',
    pictureSaving: 'Enregistrement de l\'image…',
    pictureTooBig: 'Image trop lourde (5 Mo maximum).',
    pictureBadType: 'Format non pris en charge : JPEG, PNG, WebP, GIF ou AVIF.',
    freeDelivery: 'Gratuit',
    autoFilled: 'Informations récupérées depuis la page de l\'offre : vérifiez-les et complétez avant d\'envoyer.',
    notAutoFilled: 'Nous n\'avons pas pu lire la page de l\'offre : complétez les informations ci-dessous.',
    outOfStock: 'La page de l\'offre indique que ce produit est en rupture de stock.',
    startDate: 'Début de l\'offre',
    endDate: 'Fin de l\'offre',
    description: 'Description',
    descriptionPlaceholder: 'Pourquoi est-ce un bon plan ? Conditions, comparaison de prix, avis…',
    certify: 'Je certifie que cette offre est accessible à tous et que les informations sont exactes.',
    submitting: 'Envoi…',
    submit: 'Soumettre le deal',
    successTitle: 'Merci pour votre partage !',
    successText: 'Votre deal est en cours de validation par l\'équipe. Vous gagnerez jusqu\'à {{points}} points dès sa publication.',
    seeContributions: 'Voir mes contributions',
    postAnother: 'Poster un autre deal',
    earnTitle: 'Gagnez des points',
    earnApproved: 'Des points pour chaque deal publié',
    earnPartner: 'Un bonus chez les marchands partenaires',
    earnHot: 'Encore plus quand votre deal devient hot',
    earnRewards: 'Échangez-les contre des cartes cadeaux',
    learnMore: 'Découvrir le Points Club',
    bannerText: 'Vous avez trouvé un bon plan ? Partagez-le et gagnez des points',
    bannerHow: 'Comment ça marche ?',
    bannerInvalidLink: 'Collez un lien complet, commençant par https://',
    tips: 'Conseils pour un deal accepté',
    tip1: 'Un titre clair : produit, prix et marchand',
    tip2: 'Le prix habituel, pour montrer la vraie réduction',
    tip3: 'Une offre publique, pas un lien personnel',
    required: 'Champ obligatoire',
    // Offre trouvée en magasin (photo, sans lien)
    store: {
      step: 'Photo',
      modeOnline: 'Offre en ligne',
      modeInStore: 'En magasin',
      subtitle: 'Vous avez trouvé une promo en magasin ? Photographiez l\'étiquette ou l\'affiche (et le produit) : nous lisons le maximum d\'informations, vous complétez le reste.',
      takePhoto: 'Prendre une photo',
      choosePhotos: 'Choisir des photos',
      photoHint: 'Jusqu\'à {{max}} photos : l\'étiquette de prix bien lisible, le produit, le code-barres si possible.',
      photoMax: '{{max}} photos maximum.',
      photoError: 'Cette photo n\'a pas pu être enregistrée. Réessayez avec une autre photo.',
      removePhoto: 'Retirer la photo',
      scanBarcode: 'Recherche du code-barres…',
      scanText: 'Lecture de l\'étiquette… {{percent}} %',
      analyze: 'Analyser et continuer',
      fillManually: 'Remplir à la main',
      privacyTip: 'Les photos sont analysées sur votre appareil. Elles sont réduites et leurs données cachées (dont la position GPS) sont retirées avant l\'envoi.',
      inStoreAt: 'En magasin chez {{store}}',
      photoCount: '{{count}} photo(s)',
      changePhotos: 'Changer les photos',
      autoFilled: '{{count}} information(s) détectée(s) sur la photo : vérifiez-les et complétez avant d\'envoyer.',
      notAutoFilled: 'Rien n\'a pu être lu sur la photo : complétez les informations ci-dessous.',
      detected: 'détecté',
      name: 'Enseigne',
      namePlaceholder: 'Ex. : Lidl, Carrefour, Decathlon',
      city: 'Ville ou magasin',
      cityPlaceholder: 'Ex. : Lyon 3e',
      location: 'Position du magasin',
      useLocation: 'Utiliser ma position',
      locating: 'Localisation…',
      locationSaved: 'Position enregistrée (à {{accuracy}} m près)',
      locationRemove: 'Retirer',
      locationHint: 'Facultatif : permettra de retrouver cette offre dans « Offres près de moi ». Votre position n\'est demandée qu\'en touchant ce bouton.',
      locationDenied: 'Accès à la position refusé : autorisez-le dans les réglages du navigateur, ou indiquez simplement la ville.',
      locationUnavailable: 'Position indisponible sur cet appareil : indiquez simplement la ville.',
      pictureChoose: 'Image principale du deal',
      defaultDuration: 'Sans date de fin, l\'offre restera visible {{days}} jours.',
    },
  },
  // Affichage d'une offre en magasin dans les listes et sur la fiche
  inStore: {
    badge: 'En magasin',
    at: 'En magasin · {{store}}',
    atCity: 'En magasin · {{store}}, {{city}}',
    noLink: 'Offre disponible en magasin uniquement',
  },
  // « Offres près de moi » (/pres-de-moi)
  nearby: {
    nav: 'Près de moi',
    title: 'Offres en magasin près de vous',
    intro: 'Les promotions repérées en magasin par les membres, de la plus proche à la plus lointaine.',
    useLocation: 'Utiliser ma position',
    locating: 'Localisation…',
    refresh: 'Actualiser ma position',
    radius: 'Rayon',
    km: '{{km}} km',
    meters: '{{m}} m',
    denied: 'Accès à la position refusé : autorisez-le dans les réglages du navigateur pour voir les offres autour de vous.',
    unavailable: 'Position indisponible pour le moment. Réessayez dans un instant.',
    privacy: "Votre position sert uniquement à cette recherche : elle n'est pas enregistrée ni liée à votre compte.",
    empty: "Aucune offre en magasin dans ce rayon pour l'instant. Élargissez le rayon ou postez la première offre près de chez vous !",
    postInStore: 'Poster une offre en magasin',
  },
};

export type CommunityTranslations = typeof community;
export default community;
